import { CellContext } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { FolderPermissionResponse } from '../../../../api/types.gen';
import { FolderPermissionLevel } from './PermissionEnums';
import { PermissionTableFeatures } from './permissionTableFeatures';

interface FolderPermissionCellProps {
  cellContext: CellContext<PermissionTableFeatures, FolderPermissionResponse, FolderPermissionLevel>;
}

export function FolderPermissionCell({ cellContext }: FolderPermissionCellProps) {
  const { t } = useTranslation('', { keyPrefix: 'permissions' });
  const value = cellContext.getValue();

  const isVisible = hasPermission(value, FolderPermissionLevel.Visible);
  const isContact = hasPermission(value, FolderPermissionLevel.Contact);
  const isOwner = hasPermission(value, FolderPermissionLevel.Owner);

  if (!isVisible && !isContact && !isOwner) {
    return <>{t('folderPermissionsNone')}</>;
  }

  const strings = [];
  if (isOwner) {
    strings.push(t('isFolderOwner'));
  }
  if (isContact) {
    strings.push(t('isFolderContact'));
  }
  if (isVisible) {
    strings.push(t('isFolderVisible'));
  }

  return <>{strings.join(', ')}</>;
}

// bitwise operations to check if a permission level is set
function hasPermission(value: number, flag: FolderPermissionLevel) {
  return (value & flag) === flag;
}
